import { i18n } from 'next-i18next';
import { env } from 'next-runtime-env';
import { defaultLang } from '../i18n/constants';
import { Api, QueryParamsType } from './generated';

type JwtToken = string | undefined;
export type ApiClient = Api<JwtToken>;
export interface ApiError {
  '@context': string;
  '@type': string;
  'hydra:title': string;
  'hydra:description': string;
}

class ApiOverride extends Api<JwtToken> {
  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const newKey = key.endsWith('[]') ? key : `${key}[]`;
    const value = query[key];

    return value.map((v: any) => this.encodeQueryParam(newKey, v)).join('&');
  }
}

export const createApiClient = (token?: string): ApiClient => {
  const apiClient = new ApiOverride({
    baseUrl: env('NEXT_PUBLIC_API_ENTRYPOINT'),
    baseApiParams: {
      secure: true,
      headers: {
        'Accept-Language': i18n?.language || defaultLang,
      },
    },
    securityWorker: async (securityData) => {
      const headers: HeadersInit = {
        'Accept-Language': i18n?.language || defaultLang,
      };

      if (securityData) {
        headers.Authorization = `Bearer ${securityData}`;
      }

      return {
        headers,
      };
    },
  });

  apiClient.setSecurityData(token);

  return apiClient;
};
